export default {
      id: "horn-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "icons-sprite.102705a.svg#horn-usage",
      toString: function () {
        return this.url;
      }
    }